import styles from "./CarOfBrand.module.scss";
import classNames from "classnames/bind";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import Brands from "~/Data/Brands";
import { CarsInBrand } from "~/Data/CarsInBrand";
import { Link } from "react-router-dom";
import { handleHistoryView } from "~/hooks/function";
const cx = classNames.bind(styles);
const CarOfBrand = ({ data }) => {
    const pathName = data.path;
    const carBrand = Brands.filter((e) => e.path === pathName);
    const RenderUI = CarsInBrand[carBrand[0].brand.replaceAll(" ", "")];
    const mediaQuery = window.matchMedia("(min-width: 768px)").matches;
    return (
        <div className={cx("wrapper")}>
            <div className={cx("inner")}>
                {RenderUI ? (
                    RenderUI.map((car, index) => {
                        return (
                            <Link
                                to={car.link}
                                onClick={() => handleHistoryView(car)}
                                key={index}
                                className={cx("car_wrapper")}
                            >
                                <div className={cx("car")}>
                                    <div className={cx("car_img")}>
                                        <img src={car.avatar} alt={car.name} />
                                    </div>
                                    <div className={cx("car_info")}>
                                        <p className={cx("car_name")}>
                                            {car.name}
                                        </p>
                                        <div>
                                            <p>
                                                {`${car.max} Km/h` ||
                                                    car.engine}
                                            </p>{" "}
                                            <p>{car.price} Tỷ</p>
                                        </div>
                                    </div>
                                    {!mediaQuery && (
                                        <div className={cx("btn_mobile")}>
                                            <FontAwesomeIcon
                                                icon={faAngleRight}
                                            />
                                        </div>
                                    )}
                                </div>
                                {/* {mediaQuery && (
                                    <div className={cx("btn")}>
                                        Xem thông số chi tiết
                                        <span>
                                            <FontAwesomeIcon
                                                icon={faAngleRight}
                                            />
                                        </span>
                                    </div>
                                )} */}
                            </Link>
                        );
                    })
                ) : (
                    <div></div>
                )}
            </div>
        </div>
    );
};

export default CarOfBrand;
